import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  id: "app-layout"
}
const _hoisted_2 = { id: "nav" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MobileIndex = _resolveComponent("MobileIndex")!
  const _component_theNav = _resolveComponent("theNav")!
  const _component_theSidebar = _resolveComponent("theSidebar")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_ctx.isMobileView && _ctx.title === '沁禾青果')
    ? (_openBlock(), _createBlock(_component_MobileIndex, {
        key: 0,
        onSwitchToDesktop: _ctx.handleSwitchToDesktop
      }, null, 8, ["onSwitchToDesktop"]))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_theNav),
          _createVNode(_component_theSidebar)
        ]),
        (_ctx.isReload)
          ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }, {
              default: _withCtx(({ Component }) => [
                (_openBlock(), _createBlock(_KeepAlive, null, [
                  (_ctx.$route.meta.keepAlive)
                    ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                        key: _ctx.$route.name
                      }))
                    : _createCommentVNode("", true)
                ], 1024)),
                (_ctx.$route.meta.keepAlive === false || _ctx.$route.meta.keepAlive === undefined)
                  ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                      key: _ctx.$route.name
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]))
}